import styled from "styled-components";

export const OrderReportButtonContent = styled.div`
  .btnDown {
    width: 212px;
    border: 1px solid #0E4C54;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    p {
      color: #0E4C54 !important;
    }
  }
`;

export const OrderReportModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;

  p{
    margin-bottom: 14px;
    font-size: 14px;
    color: #5B5B5B;
  }

  .modalIcon{
    width: 76px;
    height: 76px;
    margin-bottom: 20px;
  }

  hr{
    background-color: #858585;
    margin: 30px 0;
    width: 100%;
    height: 1px;
  }

  input{
    width: 354px;
    margin-bottom: 30px;
  }
`;

export const Title = styled.h1`
  font-size: 16px;
  color: #364863;
  font-weight: 700;
  margin-bottom: 35px;
`;

export const Buttons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button{
    border: 1px solid #0E4C54;
    width: 164px;
    margin-bottom: 10px;
  }

  label{
    font-size: 14px;
    color: #0E4C54;
    font-weight: 700;
  }

  .labelColor{
    button{
    color: #0E4C54;
    }
  }

  .sendButton{
    button{
      background-color: #0E4C54;
    }
  }
`;